import { useAtomValue } from 'jotai';
import { type FC } from 'react';

import { useGetClientSafetyGuard } from '../../../useGetClientSafetyGuard';
import { VisitorDrawerState, visitorMeasuresAtom } from '../../state';
import { ClientMeasuresCta } from './ClientMeasuresCta';
import { CTAProps, PreSessionPrompt, PreSessionPromptVariant } from './PreSessionPrompt';
import { ReflectionTopicsCtaWrapper } from './ReflectionTopicsCtaWrapper';
import { VibesCtaWrapper } from './VibesCtaWrapper';

export const VariantComponents: Record<PreSessionPromptVariant, FC<CTAProps>> = {
  [PreSessionPromptVariant.CLIENT_MEASURES]: ClientMeasuresCta,
  [PreSessionPromptVariant.VIBES]: VibesCtaWrapper,
  [PreSessionPromptVariant.REFLECTION_TOPICS]: ReflectionTopicsCtaWrapper,
};

export function PreSessionPromptWrapper({
  isLoading,
  variant,
  openDrawer,
}: {
  isLoading: boolean;
  variant?: PreSessionPromptVariant;
  openDrawer: (drawer: VisitorDrawerState) => void;
}) {
  const visitorMeasures = useAtomValue(visitorMeasuresAtom);
  const { requiresSafetyGuards } = useGetClientSafetyGuard();
  const showOutstandingMeasures = !!visitorMeasures?.length && requiresSafetyGuards === false;

  let CallToAction: FC<CTAProps> | null = null;
  if (showOutstandingMeasures) {
    CallToAction = null;
  } else if (isLoading) {
    // We also suppress the CTA while the page is loading, in case new data
    // coming in changes the decision about which CTA to show.
    CallToAction = null;
  } else if (variant) {
    CallToAction = VariantComponents[variant];
  }

  return (
    <PreSessionPrompt
      callToActionContent={CallToAction ? <CallToAction openDrawer={openDrawer} variant={variant} /> : null}
      hasOutstandingMeasures={showOutstandingMeasures}
    />
  );
}
